import { AjaxCall } from 'api/basicApi';

class GeneralSettingsAPI extends AjaxCall {
  constructor(command) {
    super(command);

    const { token } = SettingsInjections.getCredentials();

    this.setRetryPolicy(3, 500, 1500);
    this.appendHeader("action", command);
    this.appendHeader("token", token);
    this.appendHeader("blkType", "GBT_GENERAL_SETTINGS");
  }

  normalizeResponse(resp) {
    return resp;
  }

  getInterfaceUrl() {
    return SettingsInjections.getUsedCircuit().settings_server;
  }
}

export function GetGeneralSettings() {
  let getSettings = new GeneralSettingsAPI("cln_get_general_blk");

  return getSettings
    .POST()
    .then((resp) => {
      LogStream("APICALLDEBUG").info(
        `GetGeneralSettings() - got response:`,
        resp,
      );
      return resp;
    })
    .catch(() => {
      return false;
    });
}

export function SetGeneralSettings(json) {
  let setSettings = new GeneralSettingsAPI("cln_set_general_blk");

  setSettings.appendHeader("version", 1);
  setSettings.appendHeader("contentHash", "d41d8cd98f00b204e9800998ecf8427e");

  return setSettings
    .POST_Body(JSON.stringify(json), 'text')
    .then((resp) => {
      LogStream("APICALLDEBUG").info(
        `SetGeneralSettings() - got response:`,
        resp,
      );
      return resp == '!OK';
    })
    .catch(() => {
      return false;
    });
}
